import { Text, useTranslation } from '@obvio/app'
import { ImageInput, Stack, TextArea, TextInput } from '@obvio/ui'
import { Label } from '@obvio/ui/Form/Inputs/utils'

import { FormMultiple } from './FormMultiple'

import type { ReactElement } from 'react'

export function FormDetails(): ReactElement {
  const { t } = useTranslation()

  return (
    <>
      <ImageInput
        name="image"
        label={
          <Stack kind="vertical">
            <Label optional={false} inputKind="file" htmlFor="image">
              {t('joinForm.label.artistImage')}
            </Label>
            <Text tag="span" as="caption-1">
              {t('joinForm.label.artistImage.description')}
            </Text>
          </Stack>
        }
        renderProps={{ maxFiles: 1 }}
      />
      <TextInput name="video" label={t('joinForm.label.video')} optional />
      <TextArea
        name="statement"
        label={t('joinForm.label.artistStatement')}
        rows={10}
      />
      <TextArea name="biogram" label={t('joinForm.label.biogram')} rows={15} />
      <FormMultiple
        label={t('joinForm.label.exhibitionsHistory')}
        name="exhibitions"
        defaultNum={2}
      />
      <FormMultiple label={t('joinForm.label.awards')} name="awards" optional />
      <FormMultiple
        label={t('joinForm.label.publications')}
        name="publications"
        optional
      />
    </>
  )
}
